<div class="container">
  <div class="logo">
    <img
      src="https://assets.alpha.simadvisory.com/Cummins_logo.png"
    />
    <div>
      <div class="name">SPRICED v1.0</div>
      <div class="description">Pricing Tool</div>
    </div>
  </div>
  <div class="login">
    <button mat-button (click)="onSubmit()" class="button">SSO</button>
    <button mat-button class="button" routerLink="/localAuth">Login</button>
  </div>
</div>
